import API_MAP from "../../util/API_MAP";
import API_MANAGER from "../../util/API_MANAGER";
import router from '../../router';

const state = {
	hasData: false, // 是否请求了活动数据
	flightObj: {}, // 机票对象
	isFinish: false,
	previewUrl: '', // 预览图片网址
	isPreviewModalShow: false, // 是否展示预览
	goCityList: [], // 出发城市列表
	goFetchId: 0, // 出发城市搜索标记
	returnCityList: [], // 返程城市列表
	returnFetchId: 0, // 返程城市搜索标记
};

const getters = {
	goCityShowList: state => {
		let showList = [];
		state.goCityList.map(city => {
			showList.push(city.label);
		});
		return showList;
	},
	returnCityShowList: state => {
		let showList = [];
		state.returnCityList.map(city => {
			showList.push(city.label);
		});
		return showList;
	}
};

const actions = {
	// 提交基本信息
	getFlight({commit, rootState}) {
		let api = API_MAP.FLIGHT_INFO;
		let method = 'get';
		let payload = {};
		payload.user_id = rootState.main.currentUser['user_id'];
		let successCb = (data) => {
			commit('setHasData', true);
			commit('setFlight', data);
		};
		let errorCb = () => {

		};
		API_MANAGER({api, method, payload, successCb, errorCb, commit})
	},
	// 提交
	submitFlightInfo({commit, state, rootState}, option) {
		const {data, cb} = option;
		let api = API_MAP.FLIGHT_UPDATE;
		let method = 'json';
		let payload = data;
		const flightId = state.flightObj.id;
		if (flightId) {
			payload.id = flightId;
		}
		if (state.flightObj && state.flightObj.book_mode && state.flightObj.book_mode !== -1) {
			payload.book_mode = state.flightObj.book_mode;
		}
		payload.user_id = rootState.main.currentUser['user_id'];
		let successCb = () => {
			commit('updateFlight', {
				_data: data,
				_cb: cb
			});
		};
		let errorCb = () => {

		};
		API_MANAGER({api, method, payload, successCb, errorCb, commit});
	},
	// 修改护照号
	changeIdentityNo({commit, rootState}, data) {
		let api = API_MAP.USER_BASIC;
		let method = 'json';
		let payload = data;
		payload.user_id = rootState.main.currentUser['user_id'];
		let successCb = () => {
			commit('main/updateCurrentUser', data, { root: true });
		};
		let errorCb = () => {

		};
		API_MANAGER({api, method, payload, successCb, errorCb, commit})
	},
	// 完成状态获取
	queryIsFinish({commit, rootState}) {
		let api = API_MAP.FLIGHT_IS_FINISH;
		let method = 'get';
		let payload = {
			user_id: rootState.main.currentUser['user_id']
		};
		let successCb = (data) => {
			commit('setFinishStatus', data);
		};
		let errorCb = () => {

		};
		API_MANAGER({api, method, payload, successCb, errorCb, commit});
	},
	// 查询出发城市
	fetchGoCity({commit, state}, cityKeyWord) {
		commit('updateGoFetchId');
		const fetchId = state.goFetchId;
		let api = API_MAP.FLIGHT_CITY;
		let method = 'get';
		let payload = {
			key: cityKeyWord
		};
		let successCb = (data) => {
			if (fetchId !== state.goFetchId) { // for fetch callback order
				return;
			}
			commit('setGoCityList', data);
		};
		let errorCb = () => {
		};
		API_MANAGER({api, method, payload, successCb, errorCb, commit});
	},
	// 查询返程城市
	fetchReturnCity({commit, state}, cityKeyWord) {
		commit('updateReturnFetchId');
		const fetchId = state.returnFetchId;
		let api = API_MAP.FLIGHT_CITY;
		let method = 'get';
		let payload = {
			key: cityKeyWord
		};
		let successCb = (data) => {
			if (fetchId !== state.returnFetchId) { // for fetch callback order
				return;
			}
			commit('setReturnCityList', data);
		};
		let errorCb = () => {
		};
		API_MANAGER({api, method, payload, successCb, errorCb, commit});
	}
};

const mutations = {
	// 更新请求状态
	setHasData(state, status) {
		state.hasData = status;
	},
	// 设置机票信息
	setFlight(state, data) {
		if (!data.hasOwnProperty('is_modify')) {
			data.is_modify = true;
		}
		state.flightObj = data;
	},
	// 设置预订方式
	setBookMode(state, book_mode) {
		state.flightObj['book_mode'] = book_mode;
		state.flightObj = Object.assign({}, state.flightObj);
	},
	// 增加身份证扫描件照片
	addIdCard(state, newData) {
		state.flightObj['passport_id'].push(newData);
	},
	// 删除身份证扫描件
	deleteIdCard(state, id) {
		let currentPassportArr = state.flightObj['passport_id'];
		let resultArr = [];
		currentPassportArr.map(item => {
			if (item.id !== id) {
				resultArr.push(item);
			}
		});
		state.flightObj['passport_id'] = resultArr;
	},
	// 增加行程单照片
	addItinerary(state, newData) {
		state.flightObj['Itinerary_id'].push(newData);
	},
	// 删除身份证扫描件
	deleteItinerary(state, id) {
		let currentPassportArr = state.flightObj['Itinerary_id'];
		let resultArr = [];
		currentPassportArr.map(item => {
			if (item.id !== id) {
				resultArr.push(item);
			}
		});
		state.flightObj['Itinerary_id'] = resultArr;
	},
	// 更新机票信息
	updateFlight(state, option) {
		const data = option._data;
		const cb = option._cb;
		state.flightObj = Object.assign({}, state.flightObj, data);
		state.isFinish = true;
		cb();
	},
	// 更新完成状态
	setFinishStatus(state, data) {
		state.isFinish = !!data['is_finish'];
	},
	// 设置图片预览展示状态
	setPreviewStatus(state, status) {
		state.isPreviewModalShow = status;
	},
	// 设置预览图片地址
	setPreviewUrl(state, url) {
		state.previewUrl = url;
	},
	// 设置出发城市列表
	setGoCityList(state, list) {
		state.goCityList = JSON.parse(JSON.stringify(list));
	},
	// 设置出发城市搜索id
	updateGoFetchId(state) {
		state.goFetchId++;
	},
	// 设置出发城市列表
	setReturnCityList(state, list) {
		state.returnCityList = JSON.parse(JSON.stringify(list));
	},
	// 设置出发城市搜索id
	updateReturnFetchId(state) {
		state.returnFetchId++;
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
